import { Alert } from '@heroui/react';
import React from 'react';

const EnvironmentInfoSnackbar: React.FC = () => {

    return (
        <Alert className=" w-auto fixed rounded top-1 right-120 py-1.5 h-14"
            hideIcon
            classNames={{
                description: 'text-md font-bold text-center',
                title: 'text-md font-bold text-center',
            }}
            color="warning" variant="solid" title="Environment" description={window.config.ENVIRONMENT_NAME} />
    );

};


export default EnvironmentInfoSnackbar;